export const setAllCompanies = (allCompany) => {
  return {
    type: "SET_ALLCOMPANY",
    payload: allCompany,
  };
};

export const setAllCompanyNames = (allCompanyNames) => {
  return {
    type: "SET_ALLCOMPANYNAMES",
    payload: allCompanyNames,
  };
};

export const setAllDepartments = (allDepartments) => {
  return {
    type: "SET_ALLDEPARTMENS",
    payload: allDepartments,
  };
};

export const setAllDepartmentNames = (allDepartmentNames) => {
  return {
    type: "SET_ALLDEPARTMENTNAMES",
    payload: allDepartmentNames,
  };
};

export const setAllPositions = (allPositions) => {
  return {
    type: "SET_ALLPOSITIONS",
    payload: allPositions,
  };
};

export const setAllPositionNames = (allPositionNames) => {
  return {
    type: "SET_ALLPOSITIONNAMES",
    payload: allPositionNames,
  };
};

export const setAllEmployees = (allEmployees) => {
  return {
    type: "SET_ALLEMPLOYEES",
    payload: allEmployees,
  };
};

export const setAllAdmins = (allAdmins) => {
  return {
    type: "SET_ALLADMINS",
    payload: allAdmins,
  };
};

export const setAllMeetingRooms = (allMeetingRooms) => {
  return {
    type: "SET_ALLMEETINGROOMS",
    payload: allMeetingRooms,
  };
};

export const setAllEmployeesMails = (allEmployeesMails) => {
  return {
    type: "SET_ALLEMPLOYEESMAILS",
    payload: allEmployeesMails,
  };
};

export const setAllMeetingRoomNames = (allMeetingRoomNames) => {
  return {
    type: "SET_ALLMEETINGROOMNAMES",
    payload: allMeetingRoomNames,
  };
};

export const setAllMeetings = (allMeetings) => {
  return {
    type: "SET_ALLMEETINGS",
    payload: allMeetings,
  };
};

export const setAdminLoggedTrigger = (adminLogged) => {
  return {
    type: "SET_ADMINLOGGEDTRIGGER",
    payload: adminLogged,
  };
};
